import { render } from "./IconVisibilityOff.vue?vue&type=template&id=23121202"
import script from "./IconVisibilityOff.vue?vue&type=script&lang=js"
export * from "./IconVisibilityOff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__